/** Provides a small gradient to the bottom of the hero image to make for a clean transition of the hero to the page bg */
export default function ImagePreviewHeroGradient() {
  return (
    <div className="absolute bottom-0 left-0 right-0 z-1 h-[20%] bg-[linear-gradient(to_top,#F4F5F6_0%,transparent_100%)]" />
  );
}
